import { encodeLink } from '@draftkings/sportsbook-common-utils';

export const buildEventNavLink = (eventId: string, seoIdentifier: string) => {
    if (seoIdentifier) {
        return `/event/${encodeLink(seoIdentifier)}/${eventId}`;
    }

    return `/event/${eventId}`;
};
